/** RHF field name for “include this metadata addition in bulk base-price % increase”. */
export const getBulkBasePriceAdditionToggleFieldName = (
  metadataFieldName: string,
): `includeAdditionIncrease_${string}` =>
  `includeAdditionIncrease_${metadataFieldName}`;
